module.exports = __webpack_public_path__ + "static/media/1.555d66f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.svg
// module id = 845
// module chunks = 0